module.exports = __webpack_public_path__ + "static/media/digitalhouse.fb639d5e.jpg";